import { useTranslation } from "react-i18next";
import * as Yup from "yup";

export function SchedulingFinishedValidationSchema() {
  const { t } = useTranslation();

  const validation = Yup.object().shape({
    onlyFinished: Yup.boolean().required(t("LABEL.required")),
    settlement_status: Yup.string()
      .oneOf(["paid", "receivable"])
      .required(t("LABEL.required")),
    due_date: Yup.string().when("settlement_status", {
      is: "receivable",
      then: (schema) => schema.required(t("LABEL.required")),
      otherwise: (schema) => schema.optional(),
    }),
    accountId: Yup.string().required(t("LABEL.required")),
    categoryId: Yup.string().required(t("LABEL.required")),
    payment_method: Yup.string().required(t("LABEL.required")),
    mode: Yup.string().required(t("LABEL.required")),
    entry: Yup.string().optional(),
    type_periodic: Yup.string().when("mode", (mode, schema) => {
      return String(mode) !== "unique"
        ? schema.required(t("LABEL.required"))
        : schema.optional();
    }),
    total_installments: Yup.string().when("mode", (mode, schema) => {
      return String(mode) !== "unique"
        ? schema.required(t("LABEL.required"))
        : schema.optional();
    }),
  });

  return validation;
}
